import { InjectionToken } from '@angular/core';
import { AzureModuleOptions } from './azure.types';

export const AZURE_MODULE_OPTIONS = new InjectionToken<AzureModuleOptions>(
  'AZURE_MODULE_OPTIONS',
);
